import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public isFooterVisible: boolean;
  public showLandingVideo: boolean;
  public activeChat$: BehaviorSubject<{ contact: any, userId: any }>;

  public mapLocationChange$: BehaviorSubject<any>;
  constructor() {
    this.isFooterVisible = true;
    this.showLandingVideo = true;
    this.activeChat$ = new BehaviorSubject({ contact: null, userId: null });

    // Default to world map view - no specific country/state selected
    this.mapLocationChange$ = new BehaviorSubject({ country: null, state: null, city: null });
  }

  public hideLandingVideo() {
    this.showLandingVideo = false;
  }

  public footerShow(): void {
    this.isFooterVisible = true;
  }

  public footerHide(): void {
    this.isFooterVisible = false;
  }
}
